import { createAction, props } from '@ngrx/store';

import * as models from '../../domain/models';

export const load = createAction('[Charter.SalesAgentCollection] Load');
export const loadSuccess = createAction(
  '[Charter.SalesAgentCollection] Load Success',
  props<{ payload: Array<models.User> }>()
);
export const loadFail = createAction('[Charter.SalesAgentCollection] Load Fail');
